import React from 'react';
import {
  bool,
  func,
  oneOf,
  string,
} from 'prop-types';
import classNames from 'classnames';
import defaultStyles from './Checkbox-default.css';
import alternateStyles from './Checkbox-alternate.css';
import toggleStyles from './Checkbox-toggle.css';
import lockStyles from './Checkbox-lock.css';

const css = {
  default: defaultStyles,
  alternate: alternateStyles,
  toggle: toggleStyles,
  lock: lockStyles,
  eyeball: lockStyles,
};

const getClassNameForTheme = ({checked = false, theme = 'default'}) => {
  const _theme = css[theme] ? theme : 'default';

  const compiled = {
    default: classNames('fa fa-check', css[_theme].checkbox),
    toggle: css[_theme].checkbox,
    alternate: classNames(
      'fa',
      css[_theme].checkbox,
      checked ? 'fa-check-square-o' : 'fa-square-o'
    ),
    lock: classNames(
      'fa',
      css[_theme].checkbox,
      checked ? 'fa-lock' : 'fa-unlock'
    ),
    eyeball: classNames(
      'fa',
      css[_theme].checkbox,
      checked ? 'fa-eye' : 'fa-eye-slash'
    ),
  };

  return compiled[theme];
};

let checkboxNum = 0;

export function Checkbox(props) {
  const {checked, disabled, label, onChange, className, theme, labelPosition} = props;
  const [checkboxId] = React.useState(props.id || `sbg-checkbox-${checkboxNum++}`);

  // React.useEffect(
  //   () => {
  //     checkboxNum += 1;
  //   },
  //   []
  // );

  const onClick = (event) => {
    if (!disabled) {
      onChange(!checked, event);
    }
  };

  const onKeyPress = (event) => {
    if (!disabled && event.keyCode === 32) {
      event.preventDefault();
      onChange(!checked, event);
    }
  };

  const cssTheme = css[theme] ?? css.default;

  return (
    <div
      className={classNames(
        cssTheme.container,
        className,
        {
          [cssTheme.isChecked]: checked,
          [cssTheme.isDisabled]: disabled,
        }
      )}
      data-checked={checked}
    >
      <span
        className={getClassNameForTheme({theme, checked})}
        role="checkbox"
        tabIndex="0"
        aria-disabled={disabled}
        aria-checked={checked}
        onClick={onClick}
        onKeyPress={onKeyPress}
        id={checkboxId}
      />
      {label && (
        <label
          htmlFor={checkboxId}
          className={classNames(
            cssTheme.label,
            {[cssTheme.left]: labelPosition === 'left'}
          )}
          onClick={onClick}
        >{label}</label>
      )}
    </div>
  );
}

Checkbox.propTypes = {
  checked: bool,
  className: string,
  disabled: bool,
  id: string,
  label: string,
  labelPosition: oneOf(['left', 'right']),
  onChange: func,
  theme: oneOf(['default', 'alternate', 'toggle', 'lock', 'eyeball']),
};

Checkbox.defaultProps = {
  checked: false,
  className: '',
  disabled: false,
  label: undefined,
  labelPosition: 'right',
  theme: 'default',
  onChange: () => {
  },
};

export default Checkbox;
